// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Kyg","col":"styles_col__1_9wh"};